import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import { Button as MuiButton } from "@mui/material";
import styled from "styled-components/macro";
import downloadIcon from "../../assets/icons/downloadIcon.svg";
import { downloadFileFromS3 } from "../../utils/commonFunctions";

interface LogoUploadProps {
  setConfigDetailLogo?: any;
  setLogo?: any;
  mode: any;
  setIsSaveDisabled?: (val: any) => void;
  configDetailLogo: any;
  isShowLownloadOption?: boolean;
}

const CustomButton: any = styled(MuiButton)`
  margin-top: 11px;
  color: #223354;
  &.blue_button {
    background-color: blue;
  }

  &.custom_disabled {
    background-color: grey !important;
  }
`;

const LogoUpload: React.FC<LogoUploadProps> = ({
  setConfigDetailLogo = () => {},
  mode = "Add",
  setIsSaveDisabled = () => {},
  configDetailLogo = {},
  isShowLownloadOption = false
}) => {
  const [error, setError] = useState<string | null>(null);

  const handleLogoChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (
      event.target.files !== null &&
      event.target.files !== undefined &&
      event.target.files.length > 0
    ) {
      const file: File = event.target.files[0];
      if (file) {
        if (file.size > 1024 * 1024) {
          setError("File size should be less than 1MB.");
          // } else if (!file.type.startsWith("image/")) {
        } else if (!["image/jpeg", "image/png"].includes(file.type)) {
          setError("Only image files are allowed.");
        } else {
          let addOrUpdateNewFiles = { ...configDetailLogo };
          addOrUpdateNewFiles = {
            ...addOrUpdateNewFiles,
            Logo: URL.createObjectURL(file),
            file: file
          };

          setConfigDetailLogo(addOrUpdateNewFiles);
          setError(null);
        }
      }
      setIsSaveDisabled(false);
    } else {
      console.log("NO file selected");
    }
  };

  return (
    <div>
      <input
        type="file"
        accept=".jpeg,.jpg,.png, logo/*"
        onChange={handleLogoChange}
        style={{ display: "none" }}
        aria-label="Upload logo"
        id={"logo-upload-input"}
      />
      <label htmlFor={"logo-upload-input"}>
        <label htmlFor={"logo-upload-input"}>
          <CustomButton component="span">{mode}</CustomButton>
        </label>
      </label>
      {isShowLownloadOption && (
        <CustomButton
          component="span"
          onClick={() => downloadFileFromS3(configDetailLogo?.Logo)}
          style={{ zIndex: 1 }}
        >
          <img src={downloadIcon} alt="Icon" />
        </CustomButton>
      )}

      {error && (
        <Typography variant="body2" color="error">
          {error}
        </Typography>
      )}
    </div>
  );
};

export default LogoUpload;
